import React from "react";
import Parser, {domToReact} from "html-react-parser";
import moment from "moment";
import Latex from "react-latex";
import VideoDisplayVimeo from './components/VideoDisplay/Vimeo';
import IframeResizer from 'iframe-resizer-react';
import AudioPlayer from 'react-h5-audio-player';

import 'react-h5-audio-player/lib/styles.css';
import styles from './utils.module.css';
import striptags from "striptags";

export const getTitleColor = courseId => {
  switch (courseId) {
    case 3199:
      return styles.courseTitleVideo;
    case 3200:
      return styles.courseTitleMagazine;
    case 3201:
      return styles.courseTitleKids;
    default:
      return "";
  }
}

export const capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || ""

export const parseHtmlString = s => s && (
  (
    <div
      className={styles.learningContainer}
    >
      {Parser(s, {
        replace: node => parserReplace(node),
      })}
    </div>
  ) || <p>{s}</p>
);


export const previewCardDescription = s => {
  const replacedText = s.replaceAll('&nbsp;', '')
  const strippedText = striptags(
    replacedText,
    ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  )
  const text =  striptags(
    strippedText,
    [],
    ' '
  )

  return (
    (
      <div
        className={styles.cardContainer}
      >
        {Parser(text, {
          replace: node => parserReplace(node),
        })}
      </div>
    )
  )
};

export const courseDetailsMappingKeys = [
  "title",
  "author",
  "created_at",
  "section",
  "subjects",
]

export const replaceCourseDetailTitle = title => {
  switch (title) {
    case "title":
      return "Titolo: ";
    case "author":
      return "Autore: ";
    case "created_at":
      return "Data di creazione: ";
    case "section":
      return "Sezione: ";
    case "subjects":
      return "Materie: ";
    default:
      return title;
  }
}

export const displayCourseDetailData = (key, data) => {
  switch (key) {
    case "subjects":
      const subjectTitles = data.map(subject => subject.title);
      return subjectTitles.join(", ");
    case "created_at":
      return moment(data).format("DD/MM/YYYY");
    default:
      return capitalize(data);
  }
}

const parseLatex = domNode => {
  const {data = '', type = ''} = domNode;

  if (type === 'text' && data.trim().length > 0) {
    return <Latex>{data}</Latex>
  }

  return null;
};

const displayImage = attribs => {
  const {
    class: className = null,
    alt = '',
    "data-href": dataHref = null,
    "data-emol_src": emolSrc = null,
    src = null,
    // eslint-disable-next-line no-unused-vars
    srcset = null,  // exclude srcset from attributes to keep
    height = null,
    style = null,
    width = null,
    ...otherAttribs
  } = attribs;

  const transpiledStyle = style ?
    transpileCssString(style) :
    {};

  if (height) {
    transpiledStyle.maxHeight = `${height}px`;
  }

  if (width) {
    transpiledStyle.maxWidth = `${width}px`;
  }

  const img = (
    <img
      alt={alt}
      // height={height}
      className={className}
      src={src || emolSrc}
      style={transpiledStyle}
      // width={width}
      {...otherAttribs}
    />
  );

  return dataHref ?
      // eslint-disable-next-line
    <a
      href={dataHref}
      target="_blank"
      rel="noopener"
    >
      {img}
    </a> :
    img;
};


export function transpileCssString(cssText) {
  const regex = /([\w-]*)\s*:\s*([^;]*)/g;
  let match;
  const properties = {};
  // eslint-disable-next-line no-cond-assign
  while ((match = regex.exec(cssText))) {
    const [keyHeadChunk, ...otherKeyChunks] = match[1].split('-');
    properties[
      [keyHeadChunk, ...otherKeyChunks.map(chunk => capitalize(chunk))].join('')
      ] = match[2].trim();
  }
  return properties;
}

const parserReplace = (node, extraReplaceOptions = {}) => {

  const domNode = {...node};

  // [
  //   'href',
  //   'src',
  //   "data-href",      // image with link
  //   "data-emol_src",  // src from EMOL
  // ]
  //   .forEach(
  //     prop => {
  //       if (prop in (domNode.attribs || {})) {
  //         domNode.attribs[prop] = mapToCloudfrontURL(domNode.attribs[prop].trim());
  //       }
  //     }
  //   );

  // style fix
  if (domNode.attribs && domNode.attribs.style) {
    domNode.attribs.style = `${domNode.attribs.style
      .split(';')
      .map(chunk => chunk.trim())
      .filter(chunk => {
        const pieces = chunk.split(':');

        if (pieces.length !== 2) {
          return false;
        }

        const [key] = pieces;

        return key.trim().indexOf(' ') === -1;

      })
      .join('; ')};`;
  }

  if (domNode.type === 'tag') {
    switch (domNode.name) {
      case 'a':
        // eslint-disable-next-line no-case-declarations
        const {
          rel,
          target,
        } = domNode.attribs || {};

        // remove "noreferrer" rel if the href is from MyEdu s3 buckets
        if (
          target === '_blank' &&
          (
            /^(https|http):\/\/myeduplus.*\.s3\..*amazonaws\.com.*/.test(domNode.attribs.href) ||
            /^(https|http):\/\/myedu.*\.s3\..*amazonaws\.com.*/.test(domNode.attribs.href) ||
            /^(https|http):\/\/muba.*\.myedu\.it.*/.test(domNode.attribs.href) ||
            /^(https|http):\/\/.*\.muba\.myedu\.it.*/.test(domNode.attribs.href) ||
            /^(https|http):\/\/.*\.files\.myedu\.it.*/.test(domNode.attribs.href) ||
            /^(https|http):\/\/.*\.media\.myedu\.it.*/.test(domNode.attribs.href)
          )
        ) {
          domNode.attribs.rel = rel.replace("noreferrer", "");
        }

        return parseLatex(domNode);
      case 'code':
        return (
          <code>
            {
              (domNode.children || [])
                .reduce(
                  (acc, {data}) =>
                    acc + data,
                  ""
                )
            }
          </code>
        );
      case 'audio':
        // eslint-disable-next-line no-case-declarations
        const {
          src: audioSrc = null,
          style: audioStyle = {},
          controls,
          ...rest
        } = domNode.attribs || {};

        let audioTrack = audioSrc;

        domNode.children.forEach(
          child => {
            const {
              // name: childTagName,
              attribs: childTagAttribs = {},
            } = child || {};
            const {
              src: childTagSrc,
            } = childTagAttribs || {};

            if (childTagSrc) {
              audioTrack = childTagSrc;
            }
          }
        )

        if (audioTrack) {
          return (
            <div>
              <AudioPlayer
                src={audioTrack}
              />
            </div>
          )
        }

        return (
          <div>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <audio
              src={audioSrc || null}
              style={transpileCssString(audioStyle)}
              controls={
                controls !== undefined ?
                  'controls' :
                  null
              }
              {...rest}
            >
              {
                domToReact(domNode.children, {
                  ...extraReplaceOptions,
                  replace: n => parserReplace(n, extraReplaceOptions),
                })
              }
            </audio>
          </div>
        );
      case 'img':
        return displayImage(domNode.attribs);
      case 'div':

        // oembed
        if (
          domNode.attribs &&
          'data-oembed-url' in domNode.attribs
        ) {
          const oembedUrl = domNode.attribs['data-oembed-url'].replace(/&amp;/g, '&');

          switch (true) {
            // vimeo video url
            case new RegExp('https:\\/\\/player.vimeo.com([\\w.,@?^=%&:\\/~+#-]*[\\w@?^=%&\\/~+#-])?').test(oembedUrl):
            case new RegExp('https:\\/\\/vimeo.com([\\w.,@?^=%&:\\/~+#-]*[\\w@?^=%&\\/~+#-])?').test(oembedUrl):
              return (
                <VideoDisplayVimeo
                  url={oembedUrl}
                  onError={
                    () =>
                      domToReact(domNode.children, {
                        ...extraReplaceOptions,
                        replace: n => parserReplace(n, extraReplaceOptions),
                      })
                  }
                />
              )
            default:
              const {
                height: _,
                width: __,
                ...divAttribs
              } = domNode.attribs || {};

              return (
                <div
                  {...divAttribs}
                >
                  {
                    domToReact(domNode.children, {
                      ...extraReplaceOptions,
                      replace: n => parserReplace(n, extraReplaceOptions),
                    })
                  }
                </div>
              );
          }
        }
        break;

      case 'iframe':
        // eslint-disable-next-line no-case-declarations
        const {
          allowfullscreen = null,
          frameborder = null,
          src = null,
          style = '',
          title = null,
          height,
          width,
          ...otherAttribs
        } = domNode.attribs || {};

        switch (true) {
          case new RegExp('https:\\/\\/myedu-it.h5p.com([\\w.,@?^=%&:\\/~+#-]*[\\w@?^=%&\\/~+#-])?').test(src):
            return (
              <IframeResizer
                allowFullScreen={allowfullscreen}
                frameBorder={frameborder}
                title={title}
                style={transpileCssString(style)}
                src={src}
                {...otherAttribs}
                allow="geolocation *; microphone *; camera *; midi *; encrypted-media *"
              />
            );
          default:
            //
        }
        return (
          <IframeResizer
            {...(domNode.attribs || {})}
          />
        );

      // hidden tags
      case 'index':
        return (
          <>
            {
              domToReact(domNode.children, {
                ...extraReplaceOptions,
                replace: n => parserReplace(n, extraReplaceOptions),
              })
            }
          </>
        );
      default:
      //
    }
  }

  if (domNode.data === '/>') {
    return <></>;
  }

  return parseLatex(domNode);
};

export const translatePasswordChangeErrorMessages = message => {
  switch (message) {
    case "Password did not conform with policy: Password not long enough":
      return "La password è troppo corta";
    case "Password did not conform with policy: Password must have lowercase characters":
      return "La password deve contenere delle lettere minuscole";
    case "Password did not conform with policy: Password must have uppercase characters":
      return "La password deve contenere delle lettere maiuscole";
    case "Password did not conform with policy: Password must have numeric characters":
      return "La password deve contenere dei caratteri numerici";
    case "Incorrect username or password.":
      return "La password iniziale è errata";
    default:
      return "si è verificato un errore nel cambio della password";
  }
}

export const translateRegisterErrorMessages = message => {
  console.log(message);
  switch (message) {
    case "Token is wrong or does not exist":
      return "Il token inserito non è valido";
    case "An error occurred (InvalidPasswordException) when calling the SignUp operation: Password did not conform with policy: Password not long enough":
      return "La password deve contenere minimo 8 caratteri di cui almeno una lettera maiuscola, una minuscola e un numero";
    case "An error occurred (InvalidParameterException) when calling the SignUp operation: 1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$":
      return "La password deve contenere minimo 8 caratteri di cui almeno una lettera maiuscola, una minuscola e un numero";
    case "An error occurred (InvalidPasswordException) when calling the SignUp operation: Password did not conform with policy: Password must have uppercase characters":
      return "La password deve contenere minimo 8 caratteri di cui almeno una lettera maiuscola, una minuscola e un numero";
    case "An error occurred (UsernameExistsException) when calling the SignUp operation: User already exists":
      return "Un utente con questa email risulta già registrato, torna alla pagina di login per effettuare l'accesso o reimpostare la password";
    default:
      return "Si è verificato un errore in fase di registrazione, la preghiamo di riprovare più tardi";
  }
}
